// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1hCG0","label":"styles_label__1P5ZU"};